module.exports = __webpack_public_path__ + "img/multipayment.7469382d.svg";